import React, { useEffect, useState } from 'react';
import NavbarM from '../components/Navbar';
import Footer from '../components/Footer';
import Team from '../components/Team';
import FadeIn from '../components/FadeIn';
import mainLogo from '../img/mainLogo.svg';
import OurVision from '../components/OurVision';

const AboutUsPage = () => {
    const [scroll, setScroll] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const handleScroll = () => setScroll(window.scrollY > 100);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <div className='heroMain'>
                <div className={`heroSec heroSec--inner ${scroll ? 'heroSec__' : ''}`}>
                    <NavbarM logo={mainLogo} setNewsPage={() => {}} />
                </div>
                <div className='aboutUsPage__hero'>
                    <FadeIn direction='up'>
                        <h1 className='latestNewsPage__title text-center'>About Us</h1>
                    </FadeIn>
                    <FadeIn direction='up' delay={120}>
                        {/* <p className='aboutUsPage__text'>
                            We are experts in health, decision making and technology, driven by theory and data. We create a no compromise agent for all patients, with the goal of ensuring dignity, support, and clarity for everyone.
                        </p> */}
                        <OurVision />
                    </FadeIn>
                    <FadeIn direction='up' delay={220}>
                        <p className='aboutUsPage__tagline'>We are Epilog.</p>
                    </FadeIn>
                </div>
                <Team title="Leadership" />
            </div>
            <Footer />
        </>
    );
};

export default AboutUsPage;
